angular.module("ainapp")
    .controller("stockReserveReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Stock Reserve Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    Keyword: ""
                }
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.ReorderReport(o.data).then(function (response) {

                            angular.forEach(response.data.Data, function (e) {
                                e.TotalBalanceQty = (e.Balance + e.PurchaseOrderQty) - e.SalesOrderQty;
                            })

                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            SalesOrderQty: {
                                type: "number",
                                editable: false,
                            },
                            PurchaseOrderQty: {
                                type: "number",
                                editable: false,
                            },
                            TotalBalanceQty: {
                                type: "number",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "Balance",
                    aggregate: "sum"
                    }, {
                    field: "SalesOrderQty",
                    aggregate: "sum"
                    }, {
                    field: "PurchaseOrderQty",
                    aggregate: "sum"
                    }, {
                    field: "TotalBalanceQty",
                    aggregate: "sum"
                    }],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "ProductCode",
                        title: "Product Code",
                        },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "ParentGroupName",
                        title: "Category",
                        },
                    {
                        field: "GroupName",
                        title: "Sub Category",
                        },
                    {
                        field: "Balance",
                        title: "Quantity On Hand",
                        template: "<div style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Quantity On Hand</div>")
                    },
                    {
                        field: "SalesOrderQty",
                        title: "Committed Quantity",
                        template: "<div style='text-align: right'>#=kendo.toString(SalesOrderQty, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Committed Quantity</div>")
                    },
                    // {
                    //     field: "PurchaseOrderQty",
                    //     title: "Ordered Quantity",
                    //     template: "<div style='text-align: right'>#=kendo.toString(PurchaseOrderQty, 'n')#</div>",
                    //     footerTemplate: "#=kendo.toString(sum, 'n')#",
                    //     headerTemplate: kendo.template("<div class='headerright'>Ordered Quantity</div>")
                    // },
                    {
                        field: "TotalBalanceQty",
                        title: "Balance Quantity",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalBalanceQty, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Balance Quantity</div>")
                    }
                    ],
            };


            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Recalculate = function (id) {
                MainService.RecalculateProductStockBalance(id).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    } else {
                        toastr.error("Network Error");
                    }
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
